/*
    Default values: Don't set unless different than the default
    showBillingAddress: false
    hidePrimaryCardCheckbox: false
    hideSaveCardCheckbox: false,
    showBillingZipCode: false,
    bankCountryOptions: ["AT", "BE", "DE", "ES", "FR", "IT", "LU", "NL", "PT", "CH"]
 */

export const PAYMENT_CONFIG = {
    AT: {
        showSepaMandateOptions: true
    },
    BE: {
        bankCountryOptions: ["AT", "BE", "DE", "ES", "FR", "IT", "LU", "NL"]
    },
    CA: {
        showBillingAddress: true
    },
    DE: {
        bankCountryOptions: ["AT", "BE", "DE", "ES", "FR", "IT", "LU", "NL"],
        showSepaMandateOptions: true
    },
    IL: {
        showBillingZipCode: true,
    },
    MX: {
        showBillingZipCode: true
    },
    US: {
        showBillingAddress: true
    },
    ZA: {
        showBillingZipCode: true,
    },
};
